import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import Vuex from "vuex";

Vue.use(Vuex);
// router setup
import router from "./routes/router";
// plugin setup
Vue.use(DashboardPlugin);

import { BootstrapVue } from "bootstrap-vue";

// Import Bootstrap an BootstrapVue CSS files (order is important)

import "bootstrap-vue/dist/bootstrap-vue.css";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);

import Axios from "axios";
Vue.prototype.$axios = Axios;

import AxiosPlugin from "vue-axios-cors";
Vue.use(AxiosPlugin);

import VueSuggestion from "vue-suggestion";
Vue.use(VueSuggestion);

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
// set default config
Vue.$cookies.config("1d");

import config from "./config/index.js";
Vue.prototype.$config = config;

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import ToastPlugin from "./plugins/toast-plugin";
Vue.use(ToastPlugin);

import VueConfirmDialog from "vue-confirm-dialog";
Vue.use(VueConfirmDialog);
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);

// import VueMoment from 'vue-moment';
// Vue.use(VueMoment)

Vue.component("pulse-loader", require("vue-spinner/src/PulseLoader.vue"));

import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    // 'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    config.base_url + "css/style.css",
  ],
};
Vue.use(VueHtmlToPaper, options);

import excel from "vue-excel-export";
Vue.use(excel);

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    generateId: function (get_as_float) {
      // Returns either a string or a float containing the current time in seconds and microseconds
      //
      // version: 812.316
      // discuss at: http://phpjs.org/functions/microtime
      // +   original by: Paulo Ricardo F. Santos
      // *     example 1: timeStamp = microtime(true);
      // *     results 1: timeStamp > 1000000000 && timeStamp < 2000000000
      var now = new Date().getTime() / 1000;
      var s = parseInt(now);
      var hasil = "";
      hasil = get_as_float ? now : Math.round((now - s) * 1000) / 1000 + "" + s;
      return hasil.replace("0.", Math.floor(Math.random() * 99 + 11));
    },
    rupiah(angka) {
      var number_string = angka.toString().replace(/[^,\d]/g, ""),
        split = number_string.split(","),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi);
      var separator = "";
      // tambahkan titik jika yang di input sudah menjadi angka ribuan
      if (ribuan) {
        separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
      return "Rp. " + rupiah + ",-";
    },
  },
});

const store = new Vuex.Store({
  state: {
    name: null,
    no_hp: null,
    alamat: null,
    email: null,
    tokoNow: null,
    access_level: false,
    channel: null,
    email_status: false,
    hasMember: false,
  },
  mutations: {
    SET_CHANNEL(state, payload) {
      state.channel = payload;
    },
    SET_EMAIL_STATUS(state, payload) {
      state.email_status = payload;
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store: store,
  render: (h) => h(App),
  router,
});
